// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-widget {
  font-family: sans-serif;
  font-size: 16px;
  overflow: hidden;
  display: block;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.cesium-widget,
.cesium-widget canvas {
  width: 100%;
  height: 100%;
  touch-action: none;
}

.cesium-widget-credits {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  color: #fff;
  font-size: 10px;
  text-shadow: 0px 0px 2px #000000;
  padding-right: 5px;
}

.cesium-widget-errorPanel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99999;
}

.cesium-widget-errorPanel:before {
  display: inline-block;
  vertical-align: middle;
  height: 100%;
  content: "";
}

.cesium-widget-errorPanel-content {
  width: 75%;
  max-width: 500px;
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  border: 1px solid #510c00;
  border-radius: 7px;
  background-color: #f0d9d5;
  font-size: 14px;
  color: #510c00;
}

.cesium-widget-errorPanel-content.expanded {
  max-width: 75%;
}

.cesium-widget-errorPanel-header {
  font-size: 18px;
  font-family: "Open Sans", Verdana, Geneva, sans-serif;
  background: #d69d93;
  border-bottom: 2px solid #510c00;
  padding-bottom: 10px;
  border-radius: 3px 3px 0 0;
  padding: 15px;
}

.cesium-widget-errorPanel-scroll {
  overflow: auto;
  font-family: "Open Sans", Verdana, Geneva, sans-serif;
  white-space: pre-wrap;
  padding: 0 15px;
  margin: 10px 0 20px 0;
}

.cesium-widget-errorPanel-buttonPanel {
  padding: 0 15px;
  margin: 10px 0 20px 0;
  text-align: right;
}

.cesium-widget-errorPanel-buttonPanel button {
  border-color: #510c00;
  background: #d69d93;
  color: #202020;
  margin: 0;
}
.cesium-widget-errorPanel-buttonPanel button:focus {
  border-color: #510c00;
  background: #f0d9d5;
  color: #510c00;
}
.cesium-widget-errorPanel-buttonPanel button:hover {
  border-color: #510c00;
  background: #f0d9d5;
  color: #510c00;
}
.cesium-widget-errorPanel-buttonPanel button:active {
  border-color: #510c00;
  background: #b17b72;
  color: #510c00;
}

.cesium-widget-errorPanel-more-details {
  text-decoration: underline;
  cursor: pointer;
}

.cesium-widget-errorPanel-more-details:hover {
  color: #2b0700;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/CesiumWidget/CesiumWidget.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".cesium-widget {\n  font-family: sans-serif;\n  font-size: 16px;\n  overflow: hidden;\n  display: block;\n  position: relative;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.cesium-widget,\n.cesium-widget canvas {\n  width: 100%;\n  height: 100%;\n  touch-action: none;\n}\n\n.cesium-widget-credits {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  color: #fff;\n  font-size: 10px;\n  text-shadow: 0px 0px 2px #000000;\n  padding-right: 5px;\n}\n\n.cesium-widget-errorPanel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 99999;\n}\n\n.cesium-widget-errorPanel:before {\n  display: inline-block;\n  vertical-align: middle;\n  height: 100%;\n  content: \"\";\n}\n\n.cesium-widget-errorPanel-content {\n  width: 75%;\n  max-width: 500px;\n  display: inline-block;\n  text-align: left;\n  vertical-align: middle;\n  border: 1px solid #510c00;\n  border-radius: 7px;\n  background-color: #f0d9d5;\n  font-size: 14px;\n  color: #510c00;\n}\n\n.cesium-widget-errorPanel-content.expanded {\n  max-width: 75%;\n}\n\n.cesium-widget-errorPanel-header {\n  font-size: 18px;\n  font-family: \"Open Sans\", Verdana, Geneva, sans-serif;\n  background: #d69d93;\n  border-bottom: 2px solid #510c00;\n  padding-bottom: 10px;\n  border-radius: 3px 3px 0 0;\n  padding: 15px;\n}\n\n.cesium-widget-errorPanel-scroll {\n  overflow: auto;\n  font-family: \"Open Sans\", Verdana, Geneva, sans-serif;\n  white-space: pre-wrap;\n  padding: 0 15px;\n  margin: 10px 0 20px 0;\n}\n\n.cesium-widget-errorPanel-buttonPanel {\n  padding: 0 15px;\n  margin: 10px 0 20px 0;\n  text-align: right;\n}\n\n.cesium-widget-errorPanel-buttonPanel button {\n  border-color: #510c00;\n  background: #d69d93;\n  color: #202020;\n  margin: 0;\n}\n.cesium-widget-errorPanel-buttonPanel button:focus {\n  border-color: #510c00;\n  background: #f0d9d5;\n  color: #510c00;\n}\n.cesium-widget-errorPanel-buttonPanel button:hover {\n  border-color: #510c00;\n  background: #f0d9d5;\n  color: #510c00;\n}\n.cesium-widget-errorPanel-buttonPanel button:active {\n  border-color: #510c00;\n  background: #b17b72;\n  color: #510c00;\n}\n\n.cesium-widget-errorPanel-more-details {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.cesium-widget-errorPanel-more-details:hover {\n  color: #2b0700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
